import { fetch } from '../utils/request';

const BaseUrl = process.env.MONO_BASE;
const getUrl = (path) => `${BaseUrl}${path}`;

export default {
  getThemes() {
    return fetch(getUrl('/themes'));
  },

  getTheme(id) {
    return fetch(getUrl(`/themes/${id}`));
  },

  createTheme(fields = {}) {
    return fetch(getUrl('/themes'), {
      method: 'POST',
      body: JSON.stringify(fields),
    });
  },

  editTheme(id, fields = {}) {
    return fetch(getUrl(`/themes/${id}`), {
      method: 'PUT',
      body: JSON.stringify(fields),
    });
  },

  deleteTheme(id) {
    return fetch(getUrl(`/themes/${id}`), { method: 'DELETE' });
  },

  duplicateTheme(id) {
    return fetch(getUrl(`/themes/${id}/duplicate`), { method: 'POST' });
  },

  /**
   * Compile SCSS to CSS
   * @param {number} opts.id
   * @param {string} opts.scss
   * @param {string} opts.type
   */
  compileScss(opts = {}) {
    return fetch(getUrl('/compile-scss'), {
      method: 'POST',
      body: JSON.stringify(opts),
    });
  },
};
